var TimeFormatsEnum;
(function (TimeFormatsEnum) {
    TimeFormatsEnum["tweleveHours"] = "h:mma";
    TimeFormatsEnum["twentyFourHours"] = "HH:mm";
})(TimeFormatsEnum || (TimeFormatsEnum = {}));
export default TimeFormatsEnum;
//# sourceMappingURL=TimeFormatsEnum.js.map